module.exports = __webpack_public_path__ + "img/Differentiation-MELA_SpatialResearch.4c32a2a9.png";